<template>
  <div class="course-card-trailer">
    <div class="course-thumbnail">
      <img id="collection-image-holder" :src="item.cover_image_link" alt=""/>
      <input v-if="isOwner" ref="file" accept="image/*" style="display: none" type="file"
             @change="onChangeFile"/>
      <button v-if="isOwner" class="btn btn-primary btn-icon-label cct-upload-btn" type="button" @click="triggerFileInput">
        <span class="btn-inner--icon">
          <i class="uil-image"></i>
        </span>
        <span class="btn-inner--text">{{ $t("collectionDetail.update_image") }}</span>
      </button>
    </div>

    <div v-if="isOwner" class="p-3">
      <div class="uk-child-width-2-2 uk-grid-small" uk-grid>
        <div>
          <a class="uk-width-1-1 btn btn-danger transition-3d-hover" href="javascript:void(0)"
             @click="$emit('start')">
            <i class="uil-play"></i> {{ $t("collectionDetail.start") }}
          </a>
        </div>

        <div>
          <a class="uk-width-1-1 btn btn-danger transition-3d-hover" href="javascript:void(0)"
             @click="$emit('add-content')">
            <i class="uil-plus"></i> {{ $t("collectionDetail.add_content") }}
          </a>
        </div>
        <div v-if="item.is_public">
          <a class="uk-width-1-1 btn btn-primary transition-3d-hover" href="javascript:void(0)"
             @click="$emit('toggle-share')">
            <i class="uil-share-alt"></i>
            {{ $t("collectionDetail.share_collection") }}
          </a>
        </div>
        <div>
          <a class="uk-width-1-1 btn btn-secondary transition-3d-hover" @click="$emit('delete')">
            <i class="uil-trash-alt"></i>
            {{ $t("collectionDetail.delete") }}
          </a>
        </div>
      </div>
    </div>
    <div v-else class="p-3">
      <div class="uk-child-width-2-2 uk-grid-small mb-4" uk-grid>
        <div v-if="isFollowing">
          <a class="uk-width-1-1 btn btn-warning transition-3d-hover" href="javascript:void(0)"
             @click="$emit('follow-unfollow', 0)">
            <i class="uil-minus-circle"></i> {{ $t("collectionDetail.unfollow") }}
          </a>
        </div>
        <div v-else>
          <a class="uk-width-1-1 btn btn-danger transition-3d-hover" href="javascript:void(0)"
             @click="$emit('follow-unfollow', 1)">
            <i class="uil-plus-circle"></i> {{ $t("collectionDetail.follow") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {UPDATE_ITEM_BY_ID} from "@/core/services/store/REST.module";
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";

export default {
  name: "CollectionCardTrailer",
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    isFollowing: {
      type: Boolean,
      default: false
    },
    collectionId: {
      type: [String, Number],
      default: null
    },
    collectionDetailUrl: {
      type: String,
      default: "api/collection/"
    }
  },
  data() {
    return {
      _waitingForFile: false,
    };
  },
  mounted() {
    if (bridge.isNative) {
      this._unsubscribePickFile = bridge.on('PICK_FILE_RESULT', (payload) => {
        if (!this._waitingForFile) return;
        this._waitingForFile = false;

        if (!payload.success || !payload.file) return;
        const { name, type, base64 } = payload.file;

        // base64 → File objesine çevir
        const byteString = atob(base64);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const file = new File([ab], name, { type });
        this.uploadCoverImage(file);
      });
    }
  },
  beforeDestroy() {
    if (this._unsubscribePickFile) {
      this._unsubscribePickFile();
    }
  },
  methods: {
    triggerFileInput() {
      if (bridge.isNative) {
        this._waitingForFile = true;
        native.pickFile('image/*');
        return;
      }
      this.$refs.file.click();
    },
    onChangeFile() {
      const value = this.$refs.file.files[0];
      this.uploadCoverImage(value);
    },
    uploadCoverImage(file) {
      const form = new FormData();
      form.append("cover_image", file);
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: this.collectionDetailUrl + this.collectionId + "/photo",
        contents: form,
        acceptPromise: true
      }).then((result) => {
        if (result && result.data && result.data.cover_image_link) {
          this.$emit('cover-updated', result.data.cover_image_link);
        } else {
          this.$emit('cover-updated', URL.createObjectURL(file));
        }
      });
    },
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   GENEL (Web + Mobil)
   ═══════════════════════════════════════ */

/* Kart: border-radius 14px, soft shadow */
.course-card-trailer {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Thumbnail: kontrollü aspect-ratio, object-fit */
.course-thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #f0f0f0;
}

.course-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Butonlar: border-radius 10px, active state */
.course-card-trailer .btn {
  border-radius: 10px;
  font-weight: 600;
  line-height: 1.4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  -webkit-tap-highlight-color: transparent;
}

/* Active state — zorunlu */
.course-card-trailer .btn:active {
  transform: scale(0.98);
  opacity: 0.85;
}

/* Disabled state */
.course-card-trailer .btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Upload butonu: thumbnail üzerinde ortalanmış */
.cct-upload-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Upload butonu active'de sadece opacity, transform bozulmasın */
.cct-upload-btn:active {
  transform: translate(-50%, -50%) scale(0.98) !important;
  opacity: 0.85;
}

/* ═══════════════════════════════════════
   MOBİL (≤768px) — MOBILE_UI_GUIDELINES
   ═══════════════════════════════════════ */
@media (max-width: 768px) {
  /* Primary butonlar: min 48px, font 16px */
  .course-card-trailer .btn {
    min-height: 48px;
    font-size: 16px;
    padding: 0 16px;
  }

  /* Upload butonu: mobil touch target */
  .cct-upload-btn {
    min-height: 44px;
    font-size: 14px;
    font-weight: 500;
  }

  /* Hover efekti mobilde devre dışı */
  .course-card-trailer .transition-3d-hover:hover {
    transform: none !important;
  }

  /* İkon boyutu */
  .course-card-trailer .btn i {
    font-size: 18px;
  }
}
</style>
